import { Controller, useFormContext } from 'react-hook-form';
import NumberFormat, { NumberFormatValues, SourceInfo } from 'react-number-format';
import { IDefaultControlProps } from '../../Form';
import BaseControl from '../BaseControl/BaseControl';

export interface INumberInputProps extends IDefaultControlProps {
  format?: string;
  mask?: string;
  onValueChange?: (values: NumberFormatValues, sourceInfo: SourceInfo) => void;
}

const NumberInput = (props: INumberInputProps) => {
  const {
    name,
    label,
    placeholder,
    disabled,
    className,
    group,
    format,
    mask,
    onValueChange
  } = props;
  const { control, register } = useFormContext();
  const reg = register(name);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <BaseControl name={name} label={label} className={className} group={group}>
          <NumberFormat
            {...reg}
            {...field}
            disabled={disabled}
            placeholder={placeholder}
            format={format}
            mask={mask}
            onValueChange={onValueChange}
          />
        </BaseControl>
      )}
    />
  );
};

export default NumberInput;
